import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	LOGOUT_REQUEST,
	LOGOUT_SUCCESS,
	LOGOUT_FAILURE,
	REGISTER_REQUEST,
	REGISTER_SUCCESS,
	REGISTER_FAILURE,
	RESET_PASSWORD_REQUEST,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_FAILURE,
	SEND_VERIFICATION_CODE_REQUEST,
	SEND_VERIFICATION_CODE_SUCCESS,
	SEND_VERIFICATION_CODE_FAILURE,
	VERIFY_PHONE_NUMBER_REQUEST,
	VERIFY_PHONE_NUMBER_SUCCESS,
	VERIFY_PHONE_NUMBER_FAILURE,
	GET_MEMBER_INFO_REQUEST,
	GET_MEMBER_INFO_SUCCESS,
	GET_MEMBER_INFO_FAILURE,
	UPDATE_MEMBER_INFO_REQUEST,
	UPDATE_MEMBER_INFO_SUCCESS,
	UPDATE_MEMBER_INFO_FAILURE,
	UPDATE_CREDIT_CARD_REQUEST,
	UPDATE_CREDIT_CARD_SUCCESS,
	UPDATE_CREDIT_CARD_FAILURE,
	CLEAN_STATUS,
} from '../actions/member'

const initState = {
	isLogin: false,
	isCheckingLogin: true,

	isLoading: false,
	updateCreditCardSucc: false,
	updateCreditCardFail: false,
	verifyPhoneSucc: false,
	verifyPhoneFail: false,
}

export default (state = initState, action) => {
	switch (action.type) {
		case LOGIN_REQUEST:
			console.log('login request')
			return {
				...state,
				isLoading: true,
				isLogin: false,
			}
		case LOGIN_SUCCESS: {
			return {
				...state,
				isLoading: false
			}
		}
		case LOGIN_FAILURE: {
			return {
				...state,
				isLoading: false,
				isCheckingLogin: false,
			}
		}
		case LOGOUT_REQUEST:
			return {
				...state,
				isLoading: true
			}
		case LOGOUT_SUCCESS: {
			console.log('logout succ')
			return {
				isLoading: false,
				isLogin: false,
				isCheckingLogin: false,
			}
		}
		case LOGOUT_FAILURE: {
			return {
				...state,
			}
		}
		case VERIFY_PHONE_NUMBER_REQUEST: {
			return {
				...state,
				verifyPhoneSucc: false,
				verifyPhoneFail: false,
			}
		}
		case VERIFY_PHONE_NUMBER_SUCCESS: {
			return {
				...state,
				verifyPhoneSucc: true,
			}
		}
		case VERIFY_PHONE_NUMBER_FAILURE: {
			return {
				...state,
				verifyPhoneFail: true,
			}
		}
		case GET_MEMBER_INFO_REQUEST:
			return {
				...state,
				isLoading: true
			}
		case GET_MEMBER_INFO_SUCCESS: {
			return {
				...state,
				member: { ...action.payload },
				isLoading: false,
				isLogin: true,
				isCheckingLogin: false,
			}
		}
		case GET_MEMBER_INFO_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case UPDATE_CREDIT_CARD_REQUEST:
			return {
				...state,
				isLoading: true,
				updateCreditCardSucc: false,
				updateCreditCardFail: false,
			}
		case UPDATE_CREDIT_CARD_SUCCESS: {
			return {
				...state,
				isLoading: false,
				updateCreditCardSucc: true
			}
		}
		case UPDATE_CREDIT_CARD_FAILURE: {
			return {
				...state,
				isLoading: false,
				updateCreditCardFail: true
			}
		}
		case CLEAN_STATUS: {
			return {
				...state,
				updateCreditCardSucc: false,
				updateCreditCardFail: false,
				verifyPhoneSucc: false,
				verifyPhoneFail: false,
			}
		}
		default:
			return state
	}
}
